import { render } from "./RatingView.vue?vue&type=template&id=1c200a76"
import script from "./RatingView.vue?vue&type=script&lang=js"
export * from "./RatingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__